var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          staticClass: "custom-modal",
          attrs: {
            name: "eventDetailModal",
            id: "eventDetailModal",
            width: "75%",
            height: "auto",
            scrollable: true,
            pivotX: 1.0,
            minWidth: 900,
            minHeight: 900,
            clickToClose: true
          },
          on: {
            "before-open": _vm.beforeOpen,
            "before-close": _vm.beforeClose,
            opened: _vm.opened
          }
        },
        [
          _c(
            "div",
            { staticClass: "detail-modal", on: { click: _vm.onSave } },
            [
              _c(
                "div",
                {
                  staticClass: "overlay",
                  class: {
                    isLoading: _vm.getIsLoadingModal,
                    noDisplay: !_vm.getIsLoadingModal
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "spinner-align" },
                    [
                      _c("Icon", {
                        staticClass: "icon-size",
                        attrs: { name: "spinner", scale: "5", pulse: "" }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.getIsLoadingModal
                ? _c("div", { staticClass: "modal-padding" }, [
                    _c("div", { staticClass: "event-detail-header row" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-6 noPaddingLeft d-flex" },
                        [
                          _c(
                            "span",
                            { staticClass: "event-details text-nowrap" },
                            [_vm._v(_vm._s(_vm.event.eventName))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "add-on-wrapper ml-5" }, [
                            _c("div", { staticClass: "event-add-on" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.event.isLive,
                                    expression: "event.isLive"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  disabled: _vm.isReadOnly,
                                  id: "is-live"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.event.isLive)
                                    ? _vm._i(_vm.event.isLive, null) > -1
                                    : _vm.event.isLive
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.event.isLive,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.event,
                                              "isLive",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.event,
                                              "isLive",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.event, "isLive", $$c)
                                      }
                                    },
                                    function($event) {
                                      _vm.updateIsLiveEvent("LIVE")
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "is-live" } }, [
                                _vm._v("Toggle")
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                class: { "online-text": _vm.event.isLive }
                              },
                              [_vm._v("Live")]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 noPaddingRight align-right-item"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "modal-close-img",
                              on: { click: _vm.hideModal }
                            },
                            [_c("div", { staticClass: "icon-close" })]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-24px" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 event-information noPaddingLeft"
                          },
                          [
                            _vm._v(
                              "\n            Event information\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 event-information noPaddingRight align-right-item"
                          },
                          [
                            _c("div", { staticClass: "staffing-edit-btn" }, [
                              _vm.editing
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "ap-btn secondary btn-save",
                                      attrs: { disabled: _vm.loadingUpdate },
                                      on: { click: _vm.onSave }
                                    },
                                    [
                                      _vm.loadingUpdate
                                        ? _c("b-spinner")
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                Save\n              "
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass: "ap-btn secondary",
                                      attrs: { disabled: _vm.isReadOnly },
                                      on: { click: _vm.onEdit }
                                    },
                                    [_vm._v("Edit")]
                                  )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Event Name")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.eventName,
                                      expression: "event.eventName"
                                    }
                                  ],
                                  domProps: { value: _vm.event.eventName },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "eventName",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.eventName))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Date")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event-info" },
                            [
                              _vm.editing
                                ? _c("date-picker", {
                                    attrs: { format: "MMMM d, yyyy" },
                                    model: {
                                      value: _vm.event.prefDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.event, "prefDate", $$v)
                                      },
                                      expression: "event.prefDate"
                                    }
                                  })
                                : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFormatMMMM")(
                                          _vm.event.prefDate
                                        )
                                      )
                                    )
                                  ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Client")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm._v(_vm._s(_vm.event.clientName))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Custom Event Notes")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.customEventNote,
                                      expression: "event.customEventNote"
                                    }
                                  ],
                                  domProps: {
                                    value: _vm.event.customEventNote
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "customEventNote",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.customEventNote))
                                ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Address")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event-info" },
                            [
                              _vm.editing
                                ? _c("vue-google-autocomplete", {
                                    attrs: {
                                      name: "address-input",
                                      id: "map_address",
                                      classname: _vm.form - _vm.control,
                                      placeholder: "Address",
                                      country: ["us"],
                                      item: _vm.event
                                    },
                                    on: { placechanged: _vm.setPlace }
                                  })
                                : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                    _vm._v(_vm._s(_vm.event.fullAddress))
                                  ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Time and Duration")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event-info show-dropdown" },
                            [
                              _c("table", [
                                _c("tr", [
                                  _c("td", [_vm._v("Start: ")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm.editing
                                      ? _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.event.startTime,
                                                expression: "event.startTime"
                                              }
                                            ],
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.event,
                                                    "startTime",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                                _vm.onChangeStartTime
                                              ]
                                            }
                                          },
                                          _vm._l(_vm.listTime, function(time) {
                                            return _c(
                                              "option",
                                              {
                                                domProps: { value: time.name }
                                              },
                                              [_vm._v(_vm._s(time.name))]
                                            )
                                          })
                                        )
                                      : _c(
                                          "span",
                                          { on: { dblclick: _vm.onEdit } },
                                          [_vm._v(_vm._s(_vm.event.startTime))]
                                        )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _c("td", [_vm._v("End: ")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm.editing
                                      ? _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.event.endTime,
                                                expression: "event.endTime"
                                              }
                                            ],
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.event,
                                                    "endTime",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                                _vm.onChangeEndTime
                                              ]
                                            }
                                          },
                                          _vm._l(_vm.listTime, function(time) {
                                            return _c(
                                              "option",
                                              {
                                                domProps: { value: time.name }
                                              },
                                              [_vm._v(_vm._s(time.name))]
                                            )
                                          })
                                        )
                                      : _c(
                                          "span",
                                          { on: { dblclick: _vm.onEdit } },
                                          [_vm._v(_vm._s(_vm.event.endTime))]
                                        )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _c("td", [_vm._v("Duration: ")]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm.editing
                                        ? [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.event.duration,
                                                    expression: "event.duration"
                                                  }
                                                ],
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.$set(
                                                        _vm.event,
                                                        "duration",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                    _vm.onChangeDuration
                                                  ]
                                                }
                                              },
                                              _vm._l(
                                                _vm.arrayDuration,
                                                function(n) {
                                                  return _c(
                                                    "option",
                                                    { domProps: { value: n } },
                                                    [_vm._v(_vm._s(n))]
                                                  )
                                                }
                                              )
                                            )
                                          ]
                                        : _c(
                                            "span",
                                            { on: { dblclick: _vm.onEdit } },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.event.duration) +
                                                  " HR"
                                              )
                                            ]
                                          )
                                    ],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _c("td", [_vm._v("Time zone: ")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.event.timeZone) +
                                        "\n                  "
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.textErrorEndTime
                                ? _c("p", { staticClass: "textError" }, [
                                    _vm._v(_vm._s(_vm.textErrorEndTime))
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Program")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm._v(_vm._s(_vm.event.programName))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("On Site Instructions")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.onsiteInstruction,
                                      expression: "event.onsiteInstruction"
                                    }
                                  ],
                                  domProps: {
                                    value: _vm.event.onsiteInstruction
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "onsiteInstruction",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.onsiteInstruction))
                                ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Building/Suite")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.building,
                                      expression: "event.building"
                                    }
                                  ],
                                  domProps: { value: _vm.event.building },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "building",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.building))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("ADURO Arrival Time")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.event.aduroArrivalTime,
                                        expression: "event.aduroArrivalTime"
                                      }
                                    ],
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.event,
                                          "aduroArrivalTime",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  _vm._l(_vm.listTime, function(time) {
                                    return _c(
                                      "option",
                                      { domProps: { value: time.name } },
                                      [_vm._v(_vm._s(time.name))]
                                    )
                                  })
                                )
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.aduroArrivalTime))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("On Site Contact")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event-info" },
                            [
                              _vm.editing
                                ? [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.event.contactName,
                                          expression: "event.contactName"
                                        }
                                      ],
                                      staticClass: "mb-1",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Contact Name"
                                      },
                                      domProps: {
                                        value: _vm.event.contactName
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.event,
                                            "contactName",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.event.email,
                                          expression: "event.email"
                                        }
                                      ],
                                      staticClass: "mb-1",
                                      attrs: {
                                        type: "email",
                                        placeholder: "Contact Email"
                                      },
                                      domProps: { value: _vm.event.email },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.event,
                                            "email",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.event.phone,
                                          expression: "event.phone"
                                        }
                                      ],
                                      staticClass: "mb-1",
                                      attrs: {
                                        type: "tel",
                                        placeholder: "Contact Phone"
                                      },
                                      domProps: { value: _vm.event.phone },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.event,
                                            "phone",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _c("br")
                                  ]
                                : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.event.contactName) +
                                        "\n            "
                                    )
                                  ])
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Parking Instructions")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.parkingInformation,
                                      expression: "event.parkingInformation"
                                    }
                                  ],
                                  domProps: {
                                    value: _vm.event.parkingInformation
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "parkingInformation",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.parkingInformation))
                                ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Location")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.eventLocation,
                                      expression: "event.eventLocation"
                                    }
                                  ],
                                  domProps: { value: _vm.event.eventLocation },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "eventLocation",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.eventLocation))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Total Participants")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.projPart,
                                      expression: "event.projPart"
                                    }
                                  ],
                                  domProps: { value: _vm.event.projPart },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "projPart",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.projPart))
                                ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "event-title margin-top-16px" },
                            [_vm._v("Participation")]
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _c("div", { staticClass: "oval oval-red" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.event.numParticipant) +
                                  "/" +
                                  _vm._s(_vm.event.projPart) +
                                  " participants"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Add-ons")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event-info" },
                            _vm._l(_vm.addOns.slice(0, 7), function(
                              item,
                              index
                            ) {
                              return item.isShow
                                ? _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "add-on-wrapper"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "event-add-on mb-1" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.value,
                                                expression: "item.value"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              disabled: _vm.isReadOnly,
                                              id: item.key
                                            },
                                            domProps: {
                                              checked: Array.isArray(item.value)
                                                ? _vm._i(item.value, null) > -1
                                                : item.value
                                            },
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$a = item.value,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(item, "value", $$c)
                                                  }
                                                },
                                                function($event) {
                                                  _vm.checkboxToggle(item)
                                                }
                                              ]
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { attrs: { for: item.key } },
                                            [_vm._v("Toggle")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text" }, [
                                        _vm._v(_vm._s(item.text))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            })
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c(
                            "div",
                            { staticClass: "event-info" },
                            _vm._l(_vm.addOns.slice(7, 10), function(
                              item,
                              index
                            ) {
                              return item.isShow
                                ? _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "add-on-wrapper"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "event-add-on mb-1" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.value,
                                                expression: "item.value"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              disabled: _vm.isReadOnly,
                                              id: item.key
                                            },
                                            domProps: {
                                              checked: Array.isArray(item.value)
                                                ? _vm._i(item.value, null) > -1
                                                : item.value
                                            },
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$a = item.value,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(item, "value", $$c)
                                                  }
                                                },
                                                function($event) {
                                                  _vm.checkboxToggle(item)
                                                }
                                              ]
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { attrs: { for: item.key } },
                                            [_vm._v("Toggle")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text" }, [
                                        _vm._v(_vm._s(item.text))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            })
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c("div", { staticClass: "col-md-12 liner" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 event-information noPaddingLeft"
                        },
                        [_vm._v("\n            On Site Contacts\n          ")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.event.contactName
                      ? _c("div", { staticClass: "event-detail-body row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-4 margin-top-16px" },
                            [
                              _c("div", { staticClass: "wrapper-text" }, [
                                _c("div", { staticClass: "event-info" }, [
                                  _vm._v(_vm._s(_vm.event.contactName))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "event-info" }, [
                                  _vm._v(_vm._s(_vm.event.email))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "event-info" }, [
                                  _vm._v(_vm._s(_vm.event.phone))
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-4 margin-top-16px" },
                            [
                              _vm.showAddSecondContactButton
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "paddingTop27px" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn-add-second-contact",
                                            attrs: {
                                              title:
                                                "Add secondary on site contacts"
                                            },
                                            on: { click: _vm.onEdit }
                                          },
                                          [_vm._v("+")]
                                        )
                                      ]
                                    )
                                  ]
                                : [
                                    _vm.editing
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "event-info" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.event
                                                        .secondContactName,
                                                    expression:
                                                      "event.secondContactName"
                                                  }
                                                ],
                                                staticClass: "mb-1",
                                                attrs: {
                                                  type: "text",
                                                  placeholder:
                                                    "Enter Secondary On Site Contact's Name"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.event.secondContactName
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.event,
                                                      "secondContactName",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.event.secondEmail,
                                                    expression:
                                                      "event.secondEmail"
                                                  }
                                                ],
                                                staticClass: "mb-1",
                                                attrs: {
                                                  type: "email",
                                                  placeholder:
                                                    "Enter Secondary On Site Contact's Email"
                                                },
                                                domProps: {
                                                  value: _vm.event.secondEmail
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.event,
                                                      "secondEmail",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.event.secondPhone,
                                                    expression:
                                                      "event.secondPhone"
                                                  }
                                                ],
                                                staticClass: "mb-1",
                                                attrs: {
                                                  type: "tel",
                                                  placeholder:
                                                    "Enter Secondary On Site Contact's Phone"
                                                },
                                                domProps: {
                                                  value: _vm.event.secondPhone
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.event,
                                                      "secondPhone",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _c("br")
                                            ]
                                          )
                                        ]
                                      : _c(
                                          "div",
                                          { staticClass: "wrapper-text" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "event-info",
                                                on: { dblclick: _vm.onEdit }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.event.secondContactName
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "event-info",
                                                on: { dblclick: _vm.onEdit }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.event.secondEmail)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "event-info",
                                                on: { dblclick: _vm.onEdit }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.event.secondPhone)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                  ]
                            ],
                            2
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c("div", { staticClass: "col-md-12 liner" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 event-information noPaddingLeft"
                        },
                        [
                          _c("span", [_vm._v("Email")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "view-history-text",
                              on: { click: _vm.onViewMailHistory }
                            },
                            [_vm._v("View History")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 noPaddingRight noPaddingLeft align-right-item"
                        },
                        [
                          _c("div", { staticClass: "staffing-edit-btn" }, [
                            _c(
                              "button",
                              {
                                staticClass: "ap-btn secondary",
                                attrs: { disabled: _vm.isReadOnly },
                                on: { click: _vm.onManageEmail }
                              },
                              [_vm._v("Email Client")]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-12 email-text noPaddingLeft" },
                          [
                            _vm._v(
                              "\n            Last Email Sent: " +
                                _vm._s(
                                  _vm._f("templateName")(
                                    _vm.event.emailReminderStatus
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c("div", { staticClass: "col-md-12 liner" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-9 event-information noPaddingLeft"
                        },
                        [
                          _vm._v(
                            "\n            Staff & Slot Management\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-3 noPaddingRight noPaddingLeft align-right-item"
                        },
                        [
                          _c("div", { staticClass: "staffing-edit-btn" }, [
                            _c(
                              "button",
                              {
                                staticClass: "ap-btn secondary",
                                attrs: { disabled: _vm.isReadOnly },
                                on: { click: _vm.onManageEventStaffingDetail }
                              },
                              [_vm._v("Manage")]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-12 noPaddingLeft" }, [
                          _c(
                            "div",
                            {
                              staticClass: "wrapper-text-number display-inline"
                            },
                            [
                              _c("div", { staticClass: "oval oval-red" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "number" }, [
                                _vm._v(
                                  _vm._s(_vm.event.numStaffLead) +
                                    "/" +
                                    _vm._s(_vm.event.maxStaffLead) +
                                    " Leads"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "wrapper-text-number display-inline"
                            },
                            [
                              _c("div", {
                                staticClass: "oval oval-red margin-left-8px"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "number" }, [
                                _vm._v(
                                  _vm._s(_vm.event.numStaffConcierge) +
                                    "/" +
                                    _vm._s(_vm.event.maxStaffConcierge) +
                                    " Phlebotomists"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "wrapper-text-number display-inline"
                            },
                            [
                              _c("div", {
                                staticClass: "oval oval-red margin-left-8px"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "number" }, [
                                _vm._v(
                                  _vm._s(_vm.event.numStaffScreener) +
                                    "/" +
                                    _vm._s(_vm.event.maxStaffScreener) +
                                    " Screeners"
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c("div", { staticClass: "col-md-12 liner" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 event-information noPaddingLeft"
                        },
                        [_vm._v("\n            Shipping\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 event-information noPaddingRight noPaddingLeft align-right-item"
                        },
                        [
                          _c("div", { staticClass: "staffing-edit-btn" }, [
                            _c(
                              "button",
                              {
                                staticClass: "ap-btn secondary",
                                attrs: { disabled: _vm.isReadOnly },
                                on: {
                                  click: function($event) {
                                    _vm.generatePackingSlipBtn()
                                  }
                                }
                              },
                              [_vm._v("Generate Packing Slip")]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Address")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.shippingAddress,
                                      expression: "event.shippingAddress"
                                    }
                                  ],
                                  domProps: {
                                    value: _vm.event.shippingAddress
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "shippingAddress",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.shippingAddress))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Supplies Tracking")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "supplies-tracking-status margin-bottom-10px"
                            },
                            [
                              _c("div", {
                                staticClass: "oval",
                                class:
                                  _vm.shippingStatus !== ""
                                    ? "oval-green"
                                    : "oval-red"
                              }),
                              _vm._v(" "),
                              _c("span", {}, [
                                _vm._v(
                                  _vm._s(
                                    _vm.event.trackingNumber !== ""
                                      ? _vm.shippingStatus !== ""
                                        ? _vm.shippingStatus
                                        : "Shipping info not entered"
                                      : "Shipping info not entered"
                                  )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Tracking Number")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.trackingNumber,
                                      expression: "event.trackingNumber"
                                    }
                                  ],
                                  domProps: { value: _vm.event.trackingNumber },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "trackingNumber",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.trackingNumber))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Shipping Note")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.shippingNote,
                                      expression: "event.shippingNote"
                                    }
                                  ],
                                  domProps: { value: _vm.event.shippingNote },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "shippingNote",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.shippingNote))
                                ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c("div", { staticClass: "col-md-12 liner" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "series-related-events-section" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "related-events-top event-detail-body row"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-6 event-information noPaddingLeft"
                              },
                              [
                                _vm._v(
                                  "\n              Related Events\n              "
                                ),
                                !_vm.event.relatedEvents.length
                                  ? _c("span", [_vm._v("(0)")])
                                  : _c("span", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm.event.relatedEvents.length + 1
                                          ) +
                                          ")"
                                      )
                                    ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-6 noPaddingRight noPaddingLeft align-right-item"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "staffing-edit-btn" },
                                  [
                                    !_vm.event.relatedEvents.length
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn-add-related ap-btn secondary",
                                            on: {
                                              click: _vm.onManageRelatedEvent
                                            }
                                          },
                                          [_vm._v("Create Related Events")]
                                        )
                                      : _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn-add-related ap-btn secondary",
                                            attrs: { disabled: _vm.isReadOnly },
                                            on: {
                                              click: _vm.onManageRelatedEvent
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Manage Related Events\n                "
                                            )
                                          ]
                                        )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "related-event-container event-detail-body row"
                          },
                          [
                            _vm.event.relatedEvents.length > 0
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 margin-top-16px" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "related-event-item main-event"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "event-name",
                                              on: {
                                                click: function($event) {
                                                  _vm.relatedEventItemClick(
                                                    _vm.event.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.event.eventName)
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.event.relatedEvents, function(reEvent) {
                              return _c(
                                "div",
                                { staticClass: "col-md-3 margin-top-16px" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "related-event-item" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "event-name",
                                          on: {
                                            click: function($event) {
                                              _vm.relatedEventItemClick(
                                                reEvent.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(reEvent.eventName))]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.event.status !== "DRAFTS"
                      ? _c("div", [
                          _c("div", { staticClass: "event-detail-body row" }, [
                            _c("div", { staticClass: "col-md-12 liner" })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-detail-body row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-6 event-information noPaddingLeft"
                              },
                              [
                                _vm._v(
                                  "\n              Change History (" +
                                    _vm._s(_vm.getEventDetailHistory.length) +
                                    ")\n            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "event-detail-body row margin-top-16px"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "history-table-container" },
                                [
                                  _vm.getIsLoadingEventDetailHistory
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "list-loading d-flex justify-content-center"
                                        },
                                        [
                                          _c("b-spinner", {
                                            attrs: {
                                              variant: "primary",
                                              label: "Spinning"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _vm.getEventDetailHistory.length > 0
                                            ? _c("b-table", {
                                                attrs: {
                                                  fields:
                                                    _vm.changeHistoryTableFields,
                                                  "no-border-collapse": "",
                                                  bordered: "",
                                                  hover: "",
                                                  "head-variant": "light",
                                                  items:
                                                    _vm.getEventDetailHistory
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "cell(fieldName)",
                                                    fn: function(row) {
                                                      return [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              row.item.fieldName
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-center"
                                                },
                                                [_vm._v("No history found.")]
                                              )
                                        ],
                                        1
                                      )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("RelatedEventsModal"),
      _vm._v(" "),
      _c("ModalChangeToggleVaccines", {
        attrs: {
          onCheckToggleOnOff: _vm.onCheckToggleOnOff,
          loadingCovidSelect: _vm.loadingCovidSelect,
          addOns: _vm.addOns,
          nameModal: _vm.nameModalRemmoved,
          textQuestion: _vm.textQuestionToggleRemoved,
          textDescription: _vm.textDescriptionToggleRemoved
        }
      }),
      _vm._v(" "),
      _c("ModalChangeToggleVaccines", {
        attrs: {
          onCheckToggleOnOff: _vm.onCheckToggleOnOff,
          loadingCovidSelect: _vm.loadingCovidSelect,
          addOns: _vm.addOns,
          nameModal: _vm.nameModalSwitch,
          textQuestion: _vm.textQuestionToggleSwitch,
          textDescription: _vm.newTextDescriptionToggleSwitch
        }
      }),
      _vm._v(" "),
      _c("ModalChangeTimeEvent", {
        attrs: {
          onUpdateEventAction: _vm.onUpdateEventAction,
          loading: _vm.loadingUpdate
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43cb2843", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43cb2843","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/event/EventDetailModal.vue
// module id = 1673
// module chunks = 1